import {StrictEventEmitter} from '@gongxigames/framework/core/services/strictEventEmitter';
import {BetSelectActions} from './components/BetSelect';
import type {
    EventDataWinMeterCountUp,
    EventDataWinMeterSetValue,
    EventDataWinMeterShowingFinalValue
} from '@gongxigames/framework/slotV2/types';

export type UIMainScreenEvents = {
    'COUNT_UP': EventDataWinMeterCountUp;
    'STOP_AFTER_SHOWING_FINAL_VALUE': EventDataWinMeterShowingFinalValue;
    'STOP_FINAL_VALUE_TIMER': void;
    'SET_VALUE': EventDataWinMeterSetValue;
    'SNAP_TO_FINAL_VALUE': void;
    'STOP': void;

    'PRESSED_HOME': void;
    'PRESSED_MENU': void;
    'PRESSED_TURBO': void;
    'PRESSED_SOUND': void;
    'PRESSED_AUTOPLAY_OPTIONS': void;
    'PRESSED_BET_CHANGE': BetSelectActions;
    'PRESSED_BET_SELECT': void;
};

export const uiMainScreenEmitter = new StrictEventEmitter<UIMainScreenEvents>();